import React, { useState, useEffect, useContext } from 'react';
import { Avatar, Grid, IconButton, Stack, Typography, Fade } from '@mui/material';
import AnnonceContext from '../../../../../contexts/AnnonceContext';
import { getCategories } from 'src/service/categoriesApi';

export default function CategorySelector() {
  const { formAnnonce, setFormAnnonce, setCurrentCategory, setFormAttributes, currentCategory } = useContext(AnnonceContext);
  const [categories, setCategories] = useState([]);
  const [showAll, setShowAll] = useState(true);

  useEffect(() => {
    getCategories().then((resp) => {
      setCategories(resp);
    })
    if (currentCategory) {
      setShowAll(false);
    }
  }, [currentCategory]);

  const handleCategory = (category) => {
    setFormAnnonce({
      ...formAnnonce,
      category: `api/categories/${category.id}`,
    });
    setCurrentCategory(category);
    setFormAttributes([]);
    setShowAll(false);
  };

  const handleShowAll = () => {
    setShowAll(true);
  };

  return (
    <>
      <Grid container spacing={2} justifyContent="center">
        <Grid item md={12} sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
          {showAll ? (
            categories.map((category) => (
              <Fade in={showAll} key={category.id}>
                <Stack sx={{ width: '100px', transition: 'all 0.3s' }}>
                  <IconButton onClick={() => handleCategory(category)}>
                    <Avatar alt="" src={`/pictos/${category.image}.svg`} sx={{ width: 68, height: 68, transition: 'transform 0.3s', '&:hover': { transform: 'scale(1.1)' } }} />
                  </IconButton>
                  <Typography sx={{ fontSize: 12, textAlign: 'center' }}>{category.name}</Typography>
                </Stack>
              </Fade>
            ))
          ) : (
            currentCategory && (
              <Fade in={!showAll}>
                <Stack sx={{ width: '100px', alignItems: 'center', transition: 'all 0.3s' }}>
                  <IconButton onClick={handleShowAll}>
                    <Avatar alt="" src={`/pictos/${currentCategory.image || currentCategory.image?.image}.svg`} sx={{ width: 90, height: 90, border: '2px solid #1b9faa', transition: 'transform 0.3s', boxShadow: '0 0 10px #1b9faa' }} />
                  </IconButton>
                  <Typography sx={{ fontSize: 14, textAlign: 'center', fontWeight: 'bold', color: '#1b9faa' }}>{currentCategory.name}</Typography>
                  <Typography sx={{ fontSize: 11, textAlign: 'center', color: '#888', cursor: 'pointer', mt: 1 }} onClick={handleShowAll}>
                    Changer de catégorie
                  </Typography>
                </Stack>
              </Fade>
            )
          )}
        </Grid>
      </Grid>
    </>
  );
}
